var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1693_11372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 48.5685 50.5685 62 34 62C17.4315 62 4 48.5685 4 32C4 15.4315 17.4315 2 34 2C50.5685 2 64 15.4315 64 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 32C63.5 48.2924 50.2924 61.5 34 61.5C17.7076 61.5 4.5 48.2924 4.5 32C4.5 15.7076 17.7076 2.5 34 2.5C50.2924 2.5 63.5 15.7076 63.5 32Z",
    stroke: "#EBEBEB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0474 24.4943C27.0474 26.4564 27.751 28.1548 29.1391 29.5431C30.5271 30.9311 32.2258 31.6348 34.1879 31.6348H34.1913C36.1509 31.6341 37.8484 30.9305 39.2364 29.5431C40.6247 28.1548 41.3281 26.4564 41.3281 24.4943C41.3281 22.5329 40.6247 20.8343 39.2364 19.4462C37.849 18.0586 36.1516 17.3552 34.1913 17.3545H34.1879C32.2264 17.3545 30.5278 18.0581 29.1391 19.4462C27.751 20.8343 27.0474 22.5329 27.0474 24.4943Z",
    fill: "#FFBB85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6333 41.9017C21.6333 43.4497 22.1257 44.703 23.0956 45.626C24.0541 46.5382 25.3219 47.0003 26.8633 47.0003H41.1379C42.6793 47.0003 43.9471 46.5382 44.9049 45.626C45.8755 44.7023 46.3672 43.4493 46.3672 41.9017C46.3672 41.3064 46.3475 40.7175 46.3082 40.1511C46.2681 39.5721 46.1871 38.942 46.0677 38.2772C45.9474 37.607 45.7927 36.9735 45.6075 36.3945C45.4152 35.7951 45.1551 35.2039 44.8332 34.6375C44.4989 34.0497 44.1063 33.5376 43.6662 33.116C43.2047 32.6747 42.6407 32.3203 41.9886 32.062C41.3388 31.8051 40.6184 31.6748 39.8476 31.6748C39.5452 31.6748 39.2523 31.7985 38.6877 32.1663C38.3344 32.3968 37.9273 32.6591 37.4779 32.9464C37.0898 33.1938 36.5641 33.4259 35.9143 33.6356C35.3432 33.8203 34.7635 33.9235 34.1908 33.9413C34.1277 33.9436 34.0646 33.9447 34.0015 33.9447C33.3655 33.9447 32.7222 33.8405 32.088 33.6356C31.4382 33.4259 30.9119 33.1938 30.524 32.9464C30.0698 32.6562 29.6627 32.3941 29.3146 32.167C28.7496 31.7985 28.4572 31.6748 28.1541 31.6748C27.3839 31.6748 26.6636 31.8051 26.0133 32.062C25.3612 32.3203 24.7971 32.6754 24.3362 33.116C23.8953 33.5376 23.5027 34.0497 23.1686 34.6375C22.8465 35.2043 22.586 35.7951 22.3944 36.3938C22.2089 36.9735 22.0538 37.607 21.9335 38.2777C21.8147 38.9431 21.7335 39.5732 21.6937 40.1507C21.6537 40.7152 21.634 41.3042 21.6333 41.9017Z",
    fill: "#6AA9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1919 31.6348H34.1953V17.3545H34.1919C32.2305 17.3545 30.5319 18.0581 29.1431 19.4462C27.7551 20.8343 27.0514 22.5329 27.0514 24.4943C27.0514 26.4564 27.7551 28.1548 29.1431 29.5431C30.5312 30.9311 32.2298 31.6348 34.1919 31.6348Z",
    fill: "#F5A86C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6378 41.9017C21.6378 43.4497 22.1302 44.703 23.1001 45.626C24.0586 46.5382 25.3264 47.0003 26.8678 47.0003H34.1953V33.9413C34.1322 33.9436 34.0691 33.9447 34.006 33.9447C33.37 33.9447 32.7267 33.8405 32.0925 33.6356C31.4427 33.4259 30.9164 33.1938 30.5285 32.9464C30.0743 32.6562 29.6672 32.3941 29.3191 32.167C28.7541 31.7985 28.4617 31.6748 28.1586 31.6748C27.3884 31.6748 26.6681 31.8051 26.0178 32.062C25.3657 32.3203 24.8016 32.6754 24.3407 33.116C23.8998 33.5376 23.5072 34.0497 23.1731 34.6375C22.8511 35.2043 22.5905 35.7951 22.3989 36.3938C22.2135 36.9735 22.0583 37.607 21.938 38.2777C21.8192 38.9431 21.738 39.5732 21.6982 40.1507C21.6582 40.7152 21.6385 41.3042 21.6378 41.9017Z",
    fill: "#2682FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1693_11372",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1693_11372"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1693_11372",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.5b8bc17f8177779e937031c489295c7c.svg";
export { ForwardRef as ReactComponent };